import React from 'react';
import Icon from '../../../components/AppIcon';


const ValidationAlert = ({ errors, onDismiss }) => {
  if (!errors?.length) return null;

  // Check if this is a CORS error message
  const isCORSError = errors?.some(err => 
    err?.includes('CORS') || err?.includes('bucket')
  );

  return (
    <div className={`rounded-lg border p-4 ${
      isCORSError 
        ? 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800' :'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800'
    }`}>
      <div className="flex items-start gap-3">
        <Icon 
          name={isCORSError ? "AlertCircle" : "AlertTriangle"} 
          size={20} 
          className={
            isCORSError 
              ? "text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" :"text-yellow-600 dark:text-yellow-400 mt-0.5 flex-shrink-0"
          }
        />
        <div className="flex-1">
          <h3 className={`font-semibold mb-2 ${
            isCORSError 
              ? 'text-red-900 dark:text-red-100' :'text-yellow-900 dark:text-yellow-100'
          }`}>
            {isCORSError ? '🚨 Critical Configuration Error' : 'Validation Errors'}
          </h3>
          <div className={`space-y-1 text-sm ${
            isCORSError 
              ? 'text-red-800 dark:text-red-200' :'text-yellow-800 dark:text-yellow-200'
          }`}>
            {errors?.map((error, index) => (
              <React.Fragment key={index}>
                {error === '' ? (
                  <div className="h-2" />
                ) : error?.startsWith('JSON CORS Policy:') || 
                   error?.startsWith('[') || 
                   error?.startsWith('  {') || 
                   error?.startsWith('    "') ||
                   error?.startsWith('  }') ||
                   error?.startsWith(']') ? (
                  <code className="block bg-gray-800 text-gray-100 px-3 py-1 rounded text-xs font-mono">
                    {error}
                  </code>
                ) : error?.startsWith('📋') || 
                   error?.startsWith('💡') || 
                   error?.startsWith('🚨') ? (
                  <p className="font-semibold mt-3">{error}</p>
                ) : error?.match(/^\d+\./) ? (
                  <p className="ml-4">{error}</p>
                ) : (
                  <p>{error}</p>
                )}
              </React.Fragment>
            ))}
          </div>
          {isCORSError && (
            <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded">
              <p className="text-sm text-blue-900 dark:text-blue-100 font-medium mb-2">
                📚 Need Help?
              </p>
              <p className="text-xs text-blue-800 dark:text-blue-200">
                After updating your CORS configuration in AWS Console:
              </p>
              <ul className="text-xs text-blue-800 dark:text-blue-200 list-disc list-inside mt-1 space-y-1">
                <li>Wait 2-3 minutes for AWS to apply the changes</li>
                <li>Refresh this page and try uploading again</li>
                <li>Check browser console (F12) for detailed error logs</li>
              </ul>
            </div>
          )}
        </div>
        <button
          onClick={onDismiss}
          className="focus-ring rounded-md p-1 hover:bg-white/50 dark:hover:bg-black/20 transition-colors flex-shrink-0"
        >
          <Icon name="X" size={18} />
        </button>
      </div>
    </div>
  );
};

export default ValidationAlert;